import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { AppPropertyBasicModel, HxStoreService, storeResolveFn } from 'hx-services';
import { StoreListComponent } from '@adm-web-app/modules/stores/list/list.component';
import { StoreEditComponent } from '@adm-web-app/modules/stores/edit/edit.component';
import { StorePropertyListComponent } from '@adm-web-app/modules/stores/properties/list/list.component';
import { StorePropertyEditComponent } from '@adm-web-app/modules/stores/properties/edit/edit.component';

const storePropertyResolveFn: ResolveFn<AppPropertyBasicModel | undefined> = route => inject(HxStoreService).getPropertyByKey(Number(route.paramMap.get('storeId')), String(route.paramMap.get('key')));

export const storesRoutes: Routes = [
  {
    path: '', component: StoreListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'new', component: StoreEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':storeId/edit', component: StoreEditComponent,
    resolve: {
      model: storeResolveFn
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
  {
    path: ':storeId/properties', component: StorePropertyListComponent,
    resolve: {
      store: storeResolveFn,
    },
    data: {
      breadcrumb: 'Properties'
    }
  },
  {
    path: ':storeId/properties/new', component: StorePropertyEditComponent,
    resolve: {
      store: storeResolveFn,
    },
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':storeId/properties/:key/edit', component: StorePropertyEditComponent,
    resolve: {
      store: storeResolveFn,
      property: storePropertyResolveFn
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
];
